var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "global-page-base-layout", attrs: { loading: _vm.loading } },
    [
      _c("Caseconditons", {
        attrs: { replyShow: 0 },
        on: { choose: _vm.checkList, cleanCondition: _vm.cleanConditionData },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "handing-table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "tooltip-effect": "dark",
                "header-cell-style": { background: _vm.tableHeaderColor },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { label: "案号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.caseNo
                          ? _c(
                              "a",
                              {
                                staticClass: "link-style",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row.caseId)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.caseNo))]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "link-style",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row.caseId)
                                  },
                                },
                              },
                              [_vm._v("暂无案号")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "caseId", label: "受理号" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "registerApplyTime", label: "申请日期" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "appName", label: "申请人" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "resName", label: "被申请人" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "arbitrationReason", label: "案由" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "controversyAmount", label: "争议金额(元)" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "arbitrationAmount", label: "仲裁费(元)" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "state", label: "案件状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.caseState[scope.row.state]) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "handingSecretaryName", label: "办案秘书" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "arbitratorName", label: "仲裁员" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "registerSendTime", label: "立案时间" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !scope.row.arbitratorName
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "medium" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleReview(scope.row)
                                  },
                                },
                              },
                              [_vm._v("[指定仲裁员]")]
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "medium" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleReview(scope.row)
                                  },
                                },
                              },
                              [_vm._v("[重新指定]")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": _vm.pageSizes,
                  "page-size": 10,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "指定仲裁员",
            visible: _vm.selectArbVisible,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.selectArbVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "selectArbForm",
              attrs: {
                "label-position": "right",
                "label-width": "120px",
                model: _vm.selectArbForm,
                rules: _vm.selectArbRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "申请人选定", prop: "applicant" } },
                [
                  _vm.partyChoiceArb.appArbitratorName
                    ? _c("span", { attrs: { underline: false } }, [
                        _vm._v(_vm._s(_vm.partyChoiceArb.appArbitratorName)),
                      ])
                    : _c("span", { attrs: { underline: false } }, [
                        _vm._v("未选定仲裁员"),
                      ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "被申请人选定", prop: "respondent" } },
                [
                  _vm.partyChoiceArb.resArbitratorName
                    ? _c("el-button", [
                        _vm._v(_vm._s(_vm.partyChoiceArb.resArbitratorName)),
                      ])
                    : _c("span", { attrs: { underline: false } }, [
                        _vm._v("未选定仲裁员"),
                      ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "审理方式", prop: "trialWay" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "70%" },
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.selectArbForm.trialWay,
                        callback: function ($$v) {
                          _vm.$set(_vm.selectArbForm, "trialWay", $$v)
                        },
                        expression: "selectArbForm.trialWay",
                      },
                    },
                    _vm._l(_vm.wayList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "首席仲裁员", prop: "chiefArbitratorId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "70%" },
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.selectArbForm.chiefArbitratorId,
                        callback: function ($$v) {
                          _vm.$set(_vm.selectArbForm, "chiefArbitratorId", $$v)
                        },
                        expression: "selectArbForm.chiefArbitratorId",
                      },
                    },
                    _vm._l(_vm.arbitratorList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "仲裁员1" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "70%" },
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.selectArbForm.secondArbitratorId,
                        callback: function ($$v) {
                          _vm.$set(_vm.selectArbForm, "secondArbitratorId", $$v)
                        },
                        expression: "selectArbForm.secondArbitratorId",
                      },
                    },
                    _vm._l(_vm.arbitratorList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "仲裁员2" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "70%" },
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.selectArbForm.thirdArbitratorId,
                        callback: function ($$v) {
                          _vm.$set(_vm.selectArbForm, "thirdArbitratorId", $$v)
                        },
                        expression: "selectArbForm.thirdArbitratorId",
                      },
                    },
                    _vm._l(_vm.arbitratorList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.selectArbVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.gotoServicing },
                  on: {
                    click: function ($event) {
                      return _vm.gotoService("selectArbVisible")
                    },
                  },
                },
                [_vm._v("下一步")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.sendCaseVisible
        ? _c("send-case", {
            ref: "sendCase",
            on: {
              handleShowing: _vm.updateShow,
              handleErrorShowing: _vm.updateErrorShow,
              initList: _vm.refreshPage,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }